<script>
import ImagesCarousel from '@breakmedia/prime-vue-product/src/product-page/ImagesAndVideos/ImagesCarousel';

export default {
    extends: ImagesCarousel,
    computed: {
        isEngravingProduct() {
            // Temporarily disabled engraving
            return false;
        }
    }
};
</script>
